import React from "react";
import { DashboardList } from "@veiligh/reporting-core/ui";
import { toast } from "sonner";
import TableForData from "~/components/shared/datatable/table";

import {
  Button,
  Checkbox,
  ConfirmDeleteDialog,
  Dialog,
  DialogContent,
  DialogTitle,
  Icon,
} from "~/components/ui";

const ReportsNewDashboardPage: React.FC = () => {
  return (
    <DashboardList
      TableComponent={TableForData as any}
      tableTitle="Dashboard Management"
      ButtonComponent={Button}
      DialogComponent={Dialog}
      DialogContentComponent={DialogContent}
      DialogTitleComponent={DialogTitle}
      IconComponent={Icon}
      CheckboxComponent={Checkbox}
      ConfirmDeleteDialogComponent={ConfirmDeleteDialog}
      toast={toast}
    />
  );
};

export default ReportsNewDashboardPage;
